import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@rtkwlf/ui';
import { SingleTicketViewLink } from '../SingleTicketViewLink';
import { ROUTE_PATH } from '../../../../constants';
import { CredentialSecret } from '../../../../types';
import { memoizedCredentialSchemaSelector } from '../../../../selectors/credentialSchemaSelectors';
import { useRedirectCallback } from '../../../../hooks';
import { ACCOUNT_PURPOSE_TEXT } from '../constants';

type Props = {
  credential: CredentialSecret;
};

export const SubmissionReview: React.FunctionComponent<Props> = ({
  credential,
}) => {
  const onDone = useRedirectCallback(
    ROUTE_PATH.SELF_SERVICE.CONNECTED_ACCOUNTS.MAIN,
  );

  const schemaSelector = React.useMemo(
    () => memoizedCredentialSchemaSelector.getSchemaByType(credential.type),
    [credential.type],
  );
  const schema = useSelector(schemaSelector)!;

  const values = React.useMemo(() => {
    const fields = [
      {
        name: 'Account Type',
        value: ACCOUNT_PURPOSE_TEXT[schema.purpose] ?? '',
      },
      { name: 'Account Name', value: credential.name },
    ];
    schema.fields.forEach((field) => {
      if (credential.secrets[field.name] && field.data_type !== 'fieldchoice') {
        fields.push({
          name: field.display_name,
          value: credential.secrets[field.name],
        });
      }
    });
    return fields;
  }, [credential, schema]);

  return (
    <>
      <p className="mb-5">
        Your account information has been successfully submitted
        {credential.ticket_id && (
          <>
            {' '}
            under ticket
            <SingleTicketViewLink id={credential.ticket_id} />
          </>
        )}
        .
      </p>
      {values.map((field) => (
        <div key={field.name} data-cy={`field-${field.name}`}>
          <h5>{field.name}</h5>
          <p>{field.value}</p>
        </div>
      ))}
      <p className="my-4 text-right">
        <Button ghost onClick={onDone} data-cy="ok">
          Done
        </Button>
      </p>
    </>
  );
};
